import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressionIndicator = ({ progression }) => {
  return (
    <div className="progression-indicator bg-card border-2 border-accent rounded-sm p-4 md:p-5 lg:p-6 shadow-glow-green-md">
      <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-5">
        <Icon name="Target" size={24} color="var(--color-accent)" />
        <h3 className="text-sm md:text-base lg:text-lg font-heading font-bold text-accent tracking-wide">
          NEXT UNLOCK
        </h3>
      </div>
      <div className="space-y-4 md:space-y-5">
        <div>
          <div className="flex items-center justify-between mb-2">
            <span className="text-xs md:text-sm font-caption text-muted-foreground">
              {progression?.nextUnlock?.name}
            </span>
            <span className="text-xs md:text-sm font-data text-accent">
              {progression?.currentProgress}/{progression?.requiredProgress}
            </span>
          </div>
          <div className="w-full h-3 md:h-4 bg-background border border-accent/30 rounded-sm overflow-hidden">
            <div
              className="h-full bg-accent shadow-glow-green-sm transition-all duration-base"
              style={{ width: `${(progression?.currentProgress / progression?.requiredProgress) * 100}%` }}
            />
          </div>
        </div>

        <div className="bg-background border border-accent/30 rounded-sm p-3 md:p-4">
          <div className="flex items-start gap-3">
            <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-accent/20 rounded-sm flex items-center justify-center border border-accent">
              <Icon name={progression?.nextUnlock?.icon} size={24} color="var(--color-accent)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-heading font-bold text-foreground mb-1">
                {progression?.nextUnlock?.name}
              </h4>
              <p className="text-xs md:text-sm font-caption text-muted-foreground line-clamp-2">
                {progression?.nextUnlock?.description}
              </p>
            </div>
          </div>
        </div>

        <div className="pt-3 md:pt-4 border-t border-accent/30">
          <div className="flex items-center justify-between text-xs md:text-sm">
            <span className="font-caption text-muted-foreground">GEM RARITY</span>
            <span className="font-data text-warning">{progression?.gemRarity}</span>
          </div>
          <div className="flex items-center justify-between text-xs md:text-sm mt-2">
            <span className="font-caption text-muted-foreground">DIFFICULTY</span>
            <span className="font-data text-error">{progression?.difficulty}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressionIndicator;